export { View as PersonalFooterNerez } from './view'
